import React from "react";

const negBtnStyle = { flexShrink: 0, width: 26, height: 30, border: "1px solid #cbd5e1", borderRadius: 6, background: "#f1f5f9", color: "#334155", fontWeight: 800, fontSize: 15, cursor: "pointer", lineHeight: 1 };

/**
 * Manuel Milyem urunleri tablosu (Bilezik + Gramlar)
 * Formul: Milyem x HAS + Marj
 */
const MilyemTable = ({
  milyem,
  milyemProducts,
  inputStyle,
  colHeader,
  onUpdateField,
  onSave,
}) => (
  <div style={{ background: "#e4e4e4", borderRadius: 12, padding: 16, marginBottom: 14, boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}>
    <h3 style={{ margin: "0 0 4px", color: "#09301E", fontSize: 15 }}>⚙️ Manuel Milyem Ürünleri</h3>
    <p style={{ fontSize: 11, color: "#64748b", margin: "0 0 10px" }}>
      Formül: <code style={{ background: "#fef3c7", padding: "1px 6px", borderRadius: 3 }}>Milyem × HAS + Marj</code>
      &nbsp;— 22 Ayar bilezik sadece alış, gramlar için alış/satış milyemi ayrı
    </p>

    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12, minWidth: 750 }}>
        <thead>
          <tr>
            <th style={{ ...colHeader, textAlign: "left" }}>Ürün</th>
            <th style={colHeader}>Alış Milyem</th>
            <th style={colHeader}>Satış Milyem</th>
            <th style={colHeader}>Alış Marj</th>
            <th style={colHeader}>Satış Marj</th>
          </tr>
        </thead>
        <tbody>
          {milyemProducts.map(p => {
            const m = milyem[p.key] || {};
            const blank = (
              <span style={{ display: "block", textAlign: "center", color: "#94a3b8", fontSize: 11, padding: "8px 0" }}>—</span>
            );
            return (
              <tr key={p.key} style={{ borderBottom: "1px solid #f1f5f9" }}>
                <td style={{ padding: "8px 6px", fontWeight: 700, color: "#09301E" }}>{p.label}</td>
                {p.singleMilyem ? (
                  <td style={{ padding: 4 }} colSpan={2}>
                    <input type="text" inputMode="decimal" value={m.milyem ?? ""} onChange={e => onUpdateField(p.key, "milyem", e.target.value)} style={inputStyle} placeholder="0.912" data-testid={`ak-${p.key}-milyem`} />
                  </td>
                ) : (
                  <>
                    <td style={{ padding: 4 }}>
                      <input type="text" inputMode="decimal" value={m.alis_milyem ?? m.milyem ?? ""} onChange={e => onUpdateField(p.key, "alis_milyem", e.target.value)} style={inputStyle} placeholder="0.995" data-testid={`ak-${p.key}-alis-milyem`} />
                    </td>
                    <td style={{ padding: 4 }}>
                      <input type="text" inputMode="decimal" value={m.satis_milyem ?? m.milyem ?? ""} onChange={e => onUpdateField(p.key, "satis_milyem", e.target.value)} style={inputStyle} placeholder="0.995" data-testid={`ak-${p.key}-satis-milyem`} />
                    </td>
                  </>
                )}
                <td style={{ padding: 4 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
                    <button type="button" data-testid={`ak-${p.key}-alis-marj-neg`}
                      onClick={() => onUpdateField(p.key, "alis_marj", String(-(parseFloat(m.alis_marj) || 0)))}
                      style={negBtnStyle}>±</button>
                    <input type="text" inputMode="decimal" value={m.alis_marj ?? ""} onChange={e => onUpdateField(p.key, "alis_marj", e.target.value)} style={inputStyle} data-testid={`ak-${p.key}-alis-marj`} />
                  </div>
                </td>
                <td style={{ padding: 4 }}>
                  {p.onlyAlis ? blank : (
                    <div style={{ display: "flex", alignItems: "center", gap: 3 }}>
                      <button type="button" data-testid={`ak-${p.key}-satis-marj-neg`}
                        onClick={() => onUpdateField(p.key, "satis_marj", String(-(parseFloat(m.satis_marj) || 0)))}
                        style={negBtnStyle}>±</button>
                      <input type="text" inputMode="decimal" value={m.satis_marj ?? ""} onChange={e => onUpdateField(p.key, "satis_marj", e.target.value)} style={inputStyle} data-testid={`ak-${p.key}-satis-marj`} />
                    </div>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>

    <button onClick={onSave} data-testid="ak-save-milyem-btn"
      style={{ marginTop: 12, padding: "11px 22px", background: "#DA9F54", color: "#000", border: "none", borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
      💾 Milyem Kaydet
    </button>
  </div>
);

export default MilyemTable;
